module.exports = __webpack_public_path__ + "img/77.d1a765ca.png";